module.exports = __webpack_public_path__ + "static/media/29DUNON15.00de9100.jpg";